import type React from 'react';
import { useEffect } from 'react';

import { Alert } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';

import type { FieldError } from 'react-hook-form';

export interface OrdConflictAlertProps {
  errorField: string;
  watchField: string;
}

/** Shows a server error for a field not present in the form (e.g. domain_id),
 *  and clears it when watchField changes so the user can retry. */
export const OrdConflictAlert = ({ errorField, watchField }: OrdConflictAlertProps): React.ReactElement | null => {
  const {
    clearErrors,
    formState: { errors },
  } = useFormContext();
  const watchValue = useWatch({ name: watchField });

  useEffect(() => {
    clearErrors(errorField);
  }, [watchValue, clearErrors, errorField]);

  const errorMessage = (errors[errorField] as FieldError | undefined)?.message;
  if (errorMessage == null) return null;

  return <Alert severity='error'>{errorMessage}</Alert>;
};
